/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Encoding_ToastInputs */



/**
* | output |
* | --- |
* | "Encoding events to format..." |
*
* @param {Subtitle_Export_Encoding_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_encoding_toast = /** @type {((inputs?: Subtitle_Export_Encoding_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Encoding_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Encodage des événements au format...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisse werden in ein Format kodiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codifica degli eventi nel formato...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Кодирование событий для форматирования...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Codificación de eventos al formato...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将事件编码为格式...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントをフォーマットにエンコードしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटनाओं को प्रारूप में एन्कोड करना...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Codificando eventos para o formato...")
	return /** @type {LocalizedString} */ ("Encoding events to format...")
});